import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAlertQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type GetAlertQuery = {
  __typename?: 'Query';
  alert?: {
    __typename?: 'Alert';
    id: any;
    name: string;
    description?: string | null;
    status: Types.AlertStatus;
    triggerCount: number;
    lastTriggeredAt?: any | null;
    createdAt: any;
    updatedAt: any;
    signal?: {
      __typename?: 'Signal';
      id: any;
      name: string;
      description: string;
      signalType: Types.SignalType;
      fingerprints: Array<
        | { __typename?: 'BlockFingerprint' }
        | { __typename?: 'LogFingerprint' }
        | {
            __typename?: 'TransactionFingerprint';
            field: Types.TransactionField;
            operation: Types.ConditionOperator;
            value: {
              __typename?: 'FingerprintValue';
              valueType: Types.FingerprintValueType;
              value: any;
            };
          }
      >;
    } | null;
    destinations: Array<{
      __typename?: 'AlertDestination';
      id: any;
      destinationType: Types.AlertDestinationType;
      isEnabled: boolean;
      discordChannelId?: string | null;
      target?:
        | {
            __typename?: 'DiscordBot';
            id: any;
            botUsername?: string | null;
            guildName?: string | null;
          }
        | { __typename?: 'SlackInstallation' }
        | { __typename?: 'Webhook'; id: any; label: string; url: string }
        | null;
    }>;
    triggers: Array<{
      __typename?: 'AlertTrigger';
      id: any;
      transactionHash?: string | null;
      blockNumber?: number | null;
      triggeredValue?: string | null;
      triggeredAt: any;
    }>;
  } | null;
};

export const GetAlertDocument = gql`
  query GetAlert($id: UUID!) {
    alert(id: $id) {
      id
      name
      description
      status
      triggerCount
      lastTriggeredAt
      createdAt
      updatedAt
      signal {
        id
        name
        description
        signalType
        fingerprints {
          ... on TransactionFingerprint {
            field
            operation
            value {
              valueType
              value
            }
          }
        }
      }
      destinations {
        id
        destinationType
        isEnabled
        discordChannelId
        target {
          ... on DiscordBot {
            id
            botUsername
            guildName
          }
          ... on Webhook {
            id
            label
            url
          }
        }
      }
      triggers(limit: 10) {
        id
        transactionHash
        blockNumber
        triggeredValue
        triggeredAt
      }
    }
  }
`;

/**
 * __useGetAlertQuery__
 *
 * To run a query within a React component, call `useGetAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAlertQuery(
  baseOptions: Apollo.QueryHookOptions<GetAlertQuery, GetAlertQueryVariables> &
    ({ variables: GetAlertQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAlertQuery, GetAlertQueryVariables>(
    GetAlertDocument,
    options,
  );
}
export function useGetAlertLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAlertQuery,
    GetAlertQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAlertQuery, GetAlertQueryVariables>(
    GetAlertDocument,
    options,
  );
}
export function useGetAlertSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAlertQuery, GetAlertQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAlertQuery, GetAlertQueryVariables>(
    GetAlertDocument,
    options,
  );
}
export type GetAlertQueryHookResult = ReturnType<typeof useGetAlertQuery>;
export type GetAlertLazyQueryHookResult = ReturnType<
  typeof useGetAlertLazyQuery
>;
export type GetAlertSuspenseQueryHookResult = ReturnType<
  typeof useGetAlertSuspenseQuery
>;
export type GetAlertQueryResult = Apollo.QueryResult<
  GetAlertQuery,
  GetAlertQueryVariables
>;
